import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export enum ServiceReqTypeEnum {
  Credit = 'credit',
}

export enum ServiceReqStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum CreditReasonEnum {
  CountingError = 'counting_error',
  DeliveredAndNotInSystem = 'delivered_and_not_in_system',
  ItemWithDamage = 'item_with_damage',
  NoShow = 'no_show',
  NotAtTheWarehouse = 'not_at_the_warehouse',
  ShippingRefund = 'shipping_refund',
  WarehouseDistributionError = 'warehouse_distribution_error',
}

export enum ResponsiblePartyEnum {
  WarehouseGreece = 'GR',
  WarehouseEngland = 'UK',
  WarehouseUsa = 'USA',
  WarehouseDubai = 'UAE',
  Exelot = 'exelot',
  Shiptanbul = 'shiptanbul',
}

export enum RefundMethodEnum {
  SiteCredit = 'site_credit',
  Bit = 'bit',
  CreditCard = 'credit_card',
  BankTransfer = 'bank_transfer',
  Automatic = 'automatic',
}

export interface ServiceReqStatusUpdate {
  status: ServiceReqStatusEnum
  date: string
  reason?: CreditReasonEnum | null
  by?: string
}

export interface ServiceReq {
  id: string
  type: ServiceReqTypeEnum
  currentStatus: ServiceReqStatusEnum
  statusUpdates: ServiceReqStatusUpdate[]
  customerId: string
  customerPhone: string
  pkgId?: string | null
  orderNumber: string
  trelloUrl: string
  note?: string | null
  declaredPkgValue?: number | null
  shippingPaidTotal?: number | null
  warehouse?: PkgWarehouse | null
  xlt?: string | null
  trackingNumberInTurkey?: string | null
  shouldRefundItemsValue: boolean
  shouldRefundShipping: boolean
  createdAt: string
  updatedAt: string
  responsibleParty?: ResponsiblePartyEnum | null
  itemsRefundAmountLocal?: number | null
  itemsRefundAmountILS?: number | null
  itemsRefundMethod?: RefundMethodEnum | null
  shippingRefundAmountLocal?: number | null
  shippingRefundAmountILS?: number | null
  shippingRefundMethod?: RefundMethodEnum | null
  reportedToResponsibleParty: boolean
  reportedAt?: string | null
  reportedBy?: string | null
}

export const CREDIT_REASON_LABELS: Record<CreditReasonEnum, string> = {
  [CreditReasonEnum.CountingError]: 'Counting error',
  [CreditReasonEnum.DeliveredAndNotInSystem]: 'Delivered and Not in System',
  [CreditReasonEnum.ItemWithDamage]: 'Item with damage',
  [CreditReasonEnum.NoShow]: 'No show',
  [CreditReasonEnum.NotAtTheWarehouse]: 'NOT AT THE WAREHOUSE',
  [CreditReasonEnum.ShippingRefund]: 'Shipping Refund',
  [CreditReasonEnum.WarehouseDistributionError]: 'Warehouse Distribution Error',
}

export const RESPONSIBLE_PARTY_LABELS: Record<ResponsiblePartyEnum, string> = {
  [ResponsiblePartyEnum.WarehouseGreece]: 'Greece Warehouse',
  [ResponsiblePartyEnum.WarehouseEngland]: 'England Warehouse',
  [ResponsiblePartyEnum.WarehouseUsa]: 'USA Warehouse',
  [ResponsiblePartyEnum.WarehouseDubai]: 'Dubai Warehouse',
  [ResponsiblePartyEnum.Exelot]: 'Exelot',
  [ResponsiblePartyEnum.Shiptanbul]: 'Shiptanbul',
}

export const REFUND_METHOD_LABELS: Record<RefundMethodEnum, string> = {
  [RefundMethodEnum.SiteCredit]: 'Site Credit',
  [RefundMethodEnum.Bit]: 'Bit',
  [RefundMethodEnum.CreditCard]: 'Credit Card',
  [RefundMethodEnum.BankTransfer]: 'Bank Transfer',
  [RefundMethodEnum.Automatic]: 'Automatic',
}

export const SERVICE_REQ_STATUS_LABELS: Record<ServiceReqStatusEnum, string> = {
  [ServiceReqStatusEnum.Pending]: 'Pending',
  [ServiceReqStatusEnum.Approved]: 'Approved',
  [ServiceReqStatusEnum.Rejected]: 'Rejected',
}

export function getRejectionReason(serviceReq: ServiceReq): string | undefined {
  return serviceReq.statusUpdates?.find(u => u.status === ServiceReqStatusEnum.Rejected)?.reason ?? undefined
}

export function getApprovedAt(serviceReq: ServiceReq): string | undefined {
  return serviceReq.statusUpdates?.find(u => u.status === ServiceReqStatusEnum.Approved)?.date
}

export function isWithinMonth(date: Date, month: string): boolean {
  const [year, monthNum] = month.split('-')
  const start = new Date(parseInt(year!, 10), parseInt(monthNum!, 10) - 1, 1)
  const end = new Date(parseInt(year!, 10), parseInt(monthNum!, 10), 0, 23, 59, 59, 999)
  return date >= start && date <= end
}
